import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

function Cookies() {
  return (
    <>
        <Navbar/>
        <div className='banner2'>
        <h4> </h4>
        <h2>Cookies Policy</h2>
        {/* <p>Turn your free time into money by accompanying clients to dinners, events or trips.Organize independently, with no costs or commissions.</p> */}
        <p>Home -  Cookies  Information</p>


        </div>
        <div className='ml-pl'>
        <div class="mlcontainer">
        <h1>Informazioni sulle Tecnologie di Tracciamento</h1>
        <p>Questo documento contiene informazioni in merito alle tecnologie che consentono a <strong>wostess.com</strong> di raggiungere gli scopi descritti di seguito.</p>
        <p>Tali tecnologie permettono al Titolare di raccogliere e salvare informazioni (per esempio tramite l’utilizzo di Cookie) o di utilizzare risorse (per esempio eseguendo uno script) sul dispositivo dell’Utente quando quest’ultimo interagisce con wostess.com.</p>
        
        <h2>Strumenti di Tracciamento</h2>
        <p>Per semplicità, in questo documento tali tecnologie sono sinteticamente definite “Strumenti di Tracciamento”, salvo vi sia ragione di differenziare.</p>
        <p>Per esempio, sebbene i Cookie possano essere usati in browser sia web sia mobili, sarebbe fuori luogo parlare di Cookie nel contesto di applicazioni per dispositivi mobili, dal momento che si tratta di Strumenti di Tracciamento che richiedono la presenza di un browser.</p>
        <p>Per questo motivo, all’interno di questo documento il termine Cookie è utilizzato solo per indicare in modo specifico quel particolare tipo di Strumento di Tracciamento.</p>
        
        <h2>Consenso dell'Utente</h2>
        <p>Alcune delle finalità per le quali vengono impiegati Strumenti di Tracciamento potrebbero, inoltre, richiedere il consenso dell’Utente. Se viene prestato il consenso, esso può essere revocato liberamente in qualsiasi momento seguendo le istruzioni contenute in questo documento.</p>
        
        <h2>Tipologie di Strumenti di Tracciamento</h2>
        <p><strong>wostess.com</strong> utilizza Strumenti di Tracciamento gestiti direttamente dal Titolare (comunemente detti “di prima parte”) e Strumenti di Tracciamento che abilitano servizi forniti da terzi (comunemente detti “di terza parte”). Se non diversamente specificato, tali terzi hanno accesso ai rispettivi Strumenti di Tracciamento.</p>
        
        <h2>Durata e Scadenza</h2>
        <p>Durata e scadenza dei Cookie e degli altri Strumenti di Tracciamento possono variare a seconda di quanto impostato dal Titolare o da ciascun fornitore terzo. Alcuni di essi scadono al termine della sessione di navigazione dell’Utente.</p>
        
        <h2>Ulteriori Informazioni</h2>
        <p>Gli Utenti possono ottenere informazioni più dettagliate ed aggiornate sulla durata, così come qualsiasi altra informazione rilevante, nelle privacy policy dei rispettivi fornitori terzi o contattando il Titolare.</p>
    </div>
        </div>
        <Footer/>
    </>
  )
}

export default Cookies